import React, { useState } from 'react';
import { 
  FaChartLine, FaSearchDollar, FaShieldAlt, FaCheckCircle, 
  FaChevronDown, FaBalanceScale, FaBuilding, FaCoins 
} from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';
const StocksInvestment = () => {
  // State for Accordion FAQ toggling
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const faqs = [
    {
      q: "What is direct stocks investment and how does it work?",
      a: "Direct stock investing involves buying shares of ownership in publicly traded companies directly through a demat and trading account. When you buy a stock, you become a partial owner (shareholder) of that company, entitling you to capital appreciation and potential dividend payouts."
    },
    {
      q: "How does Lotoswealth select stocks for my portfolio?",
      a: "Our stock selection process is backed by rigorous fundamental research, valuation studies, financial statement auditing, and balance sheet health checks. We focus on companies with strong management, robust competitive moats (pricing power), consistent earnings growth, and reasonable valuations."
    },
    {
      q: "What is the difference between Large Cap, Mid Cap, and Small Cap stocks?",
      a: "Large-cap stocks are shares of well-established, industry-leading companies offering stability and steady returns. Mid-cap and small-cap stocks represent growing or emerging enterprises that offer higher growth potential but come with increased short-term price volatility."
    },
    {
      q: "How do you manage risk in a direct equity portfolio?",
      a: "We mitigate equity risk through multi-sector diversification, avoiding over-concentration in any single stock or industry, enforcing disciplined stop-loss frameworks where applicable, and focusing primarily on high-quality blue-chip and growth companies with low debt."
    }
  ];

  return (
    <main className="stocks-investment-page">
      <Helmet>
  {/* Basic SEO */}
  <title>Stock Investment Services in Hyderabad | Equity Investment Advisors | Lotoswealth</title>

  <meta
    name="description"
    content="Lotoswealth provides professional Stock Investment Services in Hyderabad, helping investors build long-term wealth through equity investments, stock market advisory, portfolio diversification, fundamental research, risk management, and personalized investment strategies."
  />

  <meta
    name="keywords"
    content="Stock Investment Hyderabad, Stock Investment Services Hyderabad, Equity Investment Hyderabad, Stock Market Investment Hyderabad, Equity Advisor Hyderabad, Stock Market Advisor Hyderabad, Investment Advisor Hyderabad, Financial Advisor Hyderabad, Wealth Management Hyderabad, Portfolio Management Hyderabad, Equity Portfolio Hyderabad, Share Market Investment Hyderabad, Long Term Stock Investment Hyderabad, Blue Chip Stocks Hyderabad, Growth Stocks Hyderabad, Dividend Stocks Hyderabad, Asset Management Hyderabad, Investment Planning Hyderabad, Wealth Creation Hyderabad, Lotoswealth"
  />

  <meta name="robots" content="index, follow" />
  <meta name="author" content="Lotoswealth" />
  <meta name="language" content="English" />

  <link
    rel="canonical"
    href="https://www.lotoswealth.com/stock-investment"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Lotoswealth" />
  <meta
    property="og:url"
    content="https://www.lotoswealth.com/stock-investment"
  />
  <meta
    property="og:title"
    content="Stock Investment Services in Hyderabad | Lotoswealth"
  />
  <meta
    property="og:description"
    content="Invest confidently with Lotoswealth's Stock Investment Services in Hyderabad. Expert equity investment strategies, portfolio diversification, market research, and long-term wealth creation."
  />
  <meta
    property="og:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="Stock Investment Services in Hyderabad | Lotoswealth"
  />
  <meta
    name="twitter:description"
    content="Grow your wealth with expert Stock Investment Services in Hyderabad. Personalized equity investment strategies, portfolio management, stock market advisory, and financial planning."
  />
  <meta
    name="twitter:image"
    content="https://www.lotoswealth.com/images/lotoswealth-logo.png"
  />
</Helmet>
      {/* =========================================
          1. HERO SECTION (With Ticker & Slow Zoom)
      ========================================= */}
      <div className="hero-wrapper position-relative" style={{ height: '100vh', minHeight: '800px', overflow: 'hidden' }}>
        
        <div className="position-absolute top-0 start-0 w-100 h-100 z-0 animate-slow-zoom">
          <img 
            src="/images/stock-investment.jpg" 
            alt="Stocks Investment Advisory" 
            className="w-100 h-100 object-fit-cover"
          />
        </div>

        {/* Slanted Panels Overlay */}
        <div className="panels-container position-absolute top-0 start-0 w-100 h-100 z-1 d-flex">
          <div className="slanted-panel panel-1"></div>
          <div className="slanted-panel panel-2"></div>
          <div className="slanted-panel panel-3"></div>
          <div className="slanted-panel panel-4"></div>
        </div>

        {/* --- Floating Main Header Text (Perfectly Centered) --- */}
        <div className="container hero-main-text text-center position-absolute top-50 start-50 translate-middle z-3 w-100 px-4">
          <h1 className="fw-bold display-4 animate-slide-up delay-1 mb-3 text-white" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
            Direct Stocks & Equity Investment
          </h1>
          <h2 className="animate-slide-up delay-2 fw-bold text-white mb-4" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Build Wealth Through Ownership in India's Finest Enterprises
          </h2>
          <p className="hero-description animate-slide-up delay-3 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Welcome to Lotoswealth. Direct equity investing is one of the most powerful vehicles for long-term capital creation. By owning shares in fundamentally strong, growing businesses, you harness the power of corporate earnings growth and economic expansion.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-4 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Successful stock investing requires more than following market trends or social media tips—it demands deep fundamental research, valuation discipline, and active risk management. Our equity advisory services cut through market noise to curate high-conviction stock portfolios tailored to your financial goals.
          </p>
          <p className="hero-description mt-3 animate-slide-up delay-5 text-white mx-auto" style={{ maxWidth: '950px', fontSize: '1.1rem', lineHeight: '1.7', textShadow: '1px 1px 3px rgba(0,0,0,0.5)' }}>
            Partner with experienced equity analysts to navigate market cycles and build a robust, diversified stock portfolio designed for sustainable wealth creation.
          </p>
        </div>

        {/* --- Scrolling Stock Ticker --- */}
        <div className="stock-ticker position-absolute bottom-0 w-100 z-3 bg-dark text-white border-top border-bottom border-secondary py-2" style={{ opacity: 0.9 }}>
          <div className="ticker-track">
            {/* First Set */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
            
            {/* Duplicated Set for Infinite Scrolling */}
            <div className="ticker-item text-white border-end border-secondary"><strong>APOLLOHOSP</strong> 8,894.00 <span className="text-danger">-63.00 (-0.70%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>ASIANPAINT</strong> 2,768.60 <span className="text-success">21.30 (0.78%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>AXISBANK</strong> 1,250.00 <span className="text-success">20.50 (1.67%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJ-AUTO</strong> 11,519.00 <span className="text-danger">-2.00 (-0.02%)</span></div>
            <div className="ticker-item text-white border-end border-secondary"><strong>BAJAJFINSV</strong> 2,085.60 <span className="text-success">56.50 (2.78%)</span></div>
          </div>
        </div>
      </div>

      {/* =========================================
          2. WHY STOCKS INVESTMENT MATTERS (Soft Teal Theme)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f0f9f6' }}>
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-6 animate-slide-up delay-1">
              <h2 className="fw-bold mb-4 text-dark">
                Why Direct Equity is Essential for Wealth Growth
              </h2>
              <p className="text-muted line-height-lg">
                Historically, direct equity has consistently outperformed most traditional asset classes over long investment horizons, acting as one of the most effective tools to beat inflation and compound wealth.
              </p>
              <p className="text-muted line-height-lg">
                Investing in individual stocks gives you direct ownership in market-leading enterprises. Rather than pooling money into generic funds, equity advisory allows you to hand-pick high-performance companies led by visionary managements with proven competitive advantages.
              </p>
            </div>
            <div className="col-lg-6 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm border-start border-teal border-5">
                <h4 className="fw-bold text-teal mb-3">Core Advantages of Our Equity Approach</h4>
                <ul className="list-unstyled text-muted mb-0">
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Direct Ownership:</strong> Hold shares directly in your own demat account.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>High Growth Potential:</strong> Outpace inflation and standard fixed-income yields.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Research-Backed:</strong> Every pick is backed by deep fundamental analysis.</li>
                  <li className="mb-2"><FaCheckCircle className="text-teal me-2" /> <strong>Dividend Income:</strong> Earn regular cash flows from dividend-paying blue chips.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =========================================
          3. OUR STOCK STRATEGIES (Crisp White)
      ========================================= */}
      <section className="py-5 bg-white" style={{ backgroundImage: "url('/images/lotoswealth-bg.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
        
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">📈 Our Stock Investment Strategies</h2>
            <p className="text-white">Structured equity portfolios designed across market capitalizations and sectors.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 animate-slide-up delay-1">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBuilding size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Blue-Chip & Large-Cap Core</h5>
                <p className="text-muted small">Invest in India's top-tier, market-leading corporations known for stable earnings, strong balance sheets, and consistent long-term wealth creation.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-2">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaChartLine size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">High-Growth Mid & Small Caps</h5>
                <p className="text-muted small">Hand-picked emerging businesses with high scalability, strong earnings momentum, and the potential to become tomorrow's market giants.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-3">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaCoins size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Dividend Yield Portfolio</h5>
                <p className="text-muted small">Focus on cash-rich companies with high dividend payout ratios, providing a reliable secondary income stream alongside capital appreciation.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-4">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaBalanceScale size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Multi-Cap Diversification</h5>
                <p className="text-muted small">A balanced equity mix distributed across large, mid, and small-cap stocks to optimize risk-adjusted returns across changing market cycles.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-5">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaSearchDollar size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Value & Special Situations</h5>
                <p className="text-muted small">Identifying fundamentally sound companies trading at temporary discounts or undergoing corporate restructurings with high upside potential.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 animate-slide-up delay-6">
              <div className="p-4 bg-light rounded-4 h-100 hover-lift-card border-bottom border-teal border-4">
                <FaShieldAlt size={36} className="text-teal mb-3" />
                <h5 className="fw-bold mb-2">Tactical Sector Rotation</h5>
                <p className="text-muted small">Overweighting or underweighting specific sectors (such as banking, IT, pharma, or infrastructure) based on macroeconomic trends and momentum.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          4. OUR 5-STEP RESEARCH PROCESS (Dark Slate)
      ========================================= */}
      <section className="py-5 text-white" style={{ backgroundColor: '#0a192f' }}>
        <div className="container py-4">
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-white">🔄 Our Equity Research & Selection Process</h2>
            <p className="text-light opacity-75">Rigorous fundamental analysis before every stock recommendation.</p>
          </div>

          <div className="row g-4">
            
            <div className="col-md-6 col-lg-4 animate-slide-up delay-1">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 1 – Quantitative Screening</h5>
                <p className="small text-muted mb-0">Filtering thousands of listed stocks using financial metrics like high ROCE/ROE, low debt-to-equity, and consistent earnings growth.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-2">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 2 – Qualitative Due Diligence</h5>
                <p className="small text-muted mb-0">Evaluating management integrity, corporate governance track records, business moats, and industry growth outlooks.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-4 animate-slide-up delay-3">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 3 – Valuation Analysis</h5>
                <p className="small text-muted mb-0">Using DCF models, P/E ratios, and peer comparisons to ensure we buy great businesses at sensible, attractive valuations.</p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 animate-slide-up delay-4">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 4 – Portfolio Construction</h5>
                <p className="small text-muted mb-0">Assembling a cohesive 15-25 stock portfolio across diverse sectors to maximize return potential while minimizing concentration risk.</p>
              </div>
            </div>

            <div className="col-md-12 col-lg-6 animate-slide-up delay-5">
              <div className="p-4 bg-white text-dark rounded-4 shadow-sm h-100 border-top border-4 border-teal">
                <h5 className="fw-bold text-teal mb-2">Step 5 – Ongoing Monitoring & Review</h5>
                <p className="small text-muted mb-0">Continuously tracking quarterly earnings reports, corporate announcements, and adjusting allocations as market dynamics shift.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          5. WHO WE SERVE & WHY CHOOSE US (Soft Blue-Gray)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#eef2f5' }}>
        <div className="container py-4">
          <div className="row g-5">
            
            {/* Target Audience */}
            <div className="col-lg-5 animate-slide-up delay-1">
              <h3 className="fw-bold mb-4 text-dark">👥 Who Benefits from Stock Advisory?</h3>
              <p className="text-muted small mb-4">Direct equity advisory is well-suited for growth-oriented investors:</p>
              <div className="d-flex flex-wrap gap-2">
                {[
                  "High Net Worth Individuals (HNIs)", "Experienced Equity Investors",
                  "Salaried Professionals Seeking Growth", "Business Owners & Entrepreneurs",
                  "Long-Term Capital Accumulators", "Active Market Participants",
                  "Retirees Seeking Dividend Streams", "Goal-Driven Wealth Builders"
                ].map((item, idx) => (
                  <span key={idx} className="badge bg-white text-dark border p-2 shadow-sm fs-6">
                    {item}
                  </span>
                ))}
              </div>
            </div>

            {/* Why Choose Lotoswealth */}
            <div className="col-lg-7 animate-slide-up delay-2">
              <div className="p-4 bg-white rounded-4 shadow-sm h-100">
                <h3 className="fw-bold mb-3 text-dark">🏆 Why Trust Lotoswealth for Equity?</h3>
                <p className="text-muted small mb-4">Stock investing requires research depth and emotional detachment. Clients trust our equity advisory because we offer:</p>
                <div className="row g-3">
                  {[
                    "Rigorous Fundamental Research", "Disciplined Valuation & Pricing Focus",
                    "Multi-Sector Portfolio Diversification", "Transparent Recommendations & Reporting",
                    "Dedicated Equity Specialists", "Active Corporate Earnings Tracking",
                    "Ethical & Client-Centric Advisory", "Long-Term Wealth Creation Strategies"
                  ].map((item, idx) => (
                    <div key={idx} className="col-md-6 d-flex align-items-center">
                      <FaCheckCircle className="text-success me-2 flex-shrink-0" />
                      <span className="small text-muted fw-bold">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================================
          6. FREQUENTLY ASKED QUESTIONS (FAQ)
      ========================================= */}
      <section className="py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container py-4" style={{ maxWidth: '850px' }}>
          <div className="text-center mb-5 animate-slide-up delay-1">
            <h2 className="fw-bold text-dark">❓ Frequently Asked Questions</h2>
            <p className="text-muted">Common queries regarding Direct Stocks & Equity Investment</p>
          </div>

          <div className="d-flex flex-column gap-3 animate-slide-up delay-2">
            {faqs.map((faq, index) => (
              <div 
                key={index} 
                className="bg-white rounded-3 shadow-sm border overflow-hidden"
              >
                <button 
                  className="w-100 text-start p-3 border-0 bg-white d-flex justify-content-between align-items-center fw-bold text-dark"
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <span className="pe-3">{faq.q}</span>
                  <FaChevronDown 
                    className={`text-teal transition-transform ${openFaq === index ? 'rotate-180' : ''}`} 
                    style={{ transition: 'transform 0.3s ease', minWidth: '16px' }}
                  />
                </button>
                {openFaq === index && (
                  <div className="p-3 pt-0 text-muted small border-top bg-light lh-lg">
                    {faq.a}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* =========================================
          7. FINAL CTA SECTION (Deep Navy)
      ========================================= */}
      <section className="py-5 text-white text-center" style={{ backgroundColor: '#0f1e2d' }}>
        <div className="container py-4">
          <h2 className="fw-bold mb-3 animate-slide-up delay-1">Ready to Build a High-Performance Stock Portfolio?</h2>
          <p className="text-light opacity-75 mb-4 animate-slide-up delay-2 mx-auto" style={{ maxWidth: '600px' }}>
            Harness the power of direct equity investing with expert research and guidance. Connect with our stock advisors today.
          </p>
          <button className="btn-custom-teal hover-lift px-5 py-3 fs-5 border-0 rounded text-white shadow animate-slide-up delay-3">
            Schedule an Equity Advisory Consultation
          </button>
        </div>
      </section>

    </main>
  );
};

export default StocksInvestment;